import { defineComponent as _defineComponent } from 'vue'
import { Icon } from '@iconify/vue2'


export default /*#__PURE__*/_defineComponent({
  __name: 'FireOutbreakNotReacted',
  props: {
    danger: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,Icon }
}

})